import FormService from "../../../services/form";
import ContactService from "../../../services/contact";
import { getRandomAlphaNumericString } from "../../../utility/Utility";

export default class Template5 {
  static getData() {
    return {
      metaData: null,
      scripts: null,
      hash: getRandomAlphaNumericString(),
      designElements: [
        {
          type: "Image",
          value:
            "https://s3.ap-southeast-1.amazonaws.com/cdn-crm-common-env/report/thumbnail/70932/1625653544151_form_template_5.png",
          style: {
            width: "100%",
            boxSizing: "border-box",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            marginTop: 10,
            marginBottom: 10,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            alignSelf: "center",
            overflow: "hidden",
            textAlign: "center",
          },
        },
        {
          type: "Text",
          value: "Start building your career today!",
          style: {
            width: "76%",
            boxSizing: "border-box",
            fontSize: 32,
            color: "#233761",
            textAlign: "center",
            fontWeight: "bold",
            paddingTop: 16,
            paddingBottom: 8,
            paddingLeft: 8,
            paddingRight: 8,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "center",
            whiteSpace: "pre-wrap",
          },
        },
        {
            type: "Text",
            value:
              "Thanks for your interest in Deskera! Please give us some more information about yourself and we'll be in touch soon.",
            style: {
              width: "82%",
              boxSizing: "border-box",
              fontSize: 14,
              color: "#979595",
              textAlign: "center",
              fontWeight: "normal",
              paddingTop: 6,
              paddingBottom: 6,
              paddingLeft: 6,
              paddingRight: 6,
              marginTop: 0,
              marginBottom: 0,
              marginLeft: "auto",
              marginRight: "auto",
              borderRadius: 0,
              backgroundColor: "transparent",
              overflow: "hidden",
              alignSelf: "center",
              whiteSpace: "pre-wrap",
            },
        },
        {
          type: "Form",
          value: FormService.getContactData(true),
          segmentId:
            ContactService.getSegments().length > 0
              ? ContactService.getSegments()[0].id
              : "",
          style: {
            width: "80%",
            boxSizing: "border-box",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            marginTop: 16,
            marginBottom: 16,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            alignSelf: "center",
            overflow: "hidden",
            fieldSpacing: 10,
            labelSize: 12,
            labelColor: "#000000",
            fieldRadius: 4,
            fieldBorder: "#EBEBEB",
            fieldBackground: "#F8F7FA",
          },
          button: {
            value: "Submit",
            style: {
              buttonColor: "#ffffff",
              buttonSize: 18,
              buttonBackground: "#233761",
            },
          },
          thankYouMsg: "Thank you for submitting form!",
          redirectURL: "",
        },
      ],
    };
  }
}
